const URL_PARAMS = {
  globalSortingOption: 'sorting',
  globalFilterOption: 'filter',
  globalTypeOption: 'type',
  textSearch: 'query',
  sortId: 'sortId',
  sorting: 'sortDirection',
  startDateRange: 'dateStart',
  endDateRange: 'dateEnd',
  displayElementsNumber: 'rows',
  pageIndex: 'pageIndex',
  filterCategory: 'filterCategory',
  filterAspectRatio: 'filterAspectRatio',
  filterAssetType: 'filterAssetType',
  filterType: 'filterType',
  filterTenant: 'filterTenant',
  filterFolder: 'filterFolder',
  filterFollowable: 'filterFollowable',
};

export interface DataTableURLParamKeys {
  pageIndex: string;
  displayElementsNumber: string;
  sortId: string;
  sorting: string;
}

export const getDataTableURLParamKeys = (
  namespace?: string
): DataTableURLParamKeys =>
  namespace
    ? {
        pageIndex: `${namespace}.page`,
        displayElementsNumber: `${namespace}.rows`,
        sortId: `${namespace}.sort`,
        sorting: `${namespace}.direction`,
      }
    : {
        pageIndex: URL_PARAMS.pageIndex,
        displayElementsNumber: URL_PARAMS.displayElementsNumber,
        sortId: URL_PARAMS.sortId,
        sorting: URL_PARAMS.sorting,
      };

export default URL_PARAMS;
